import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client";
import "./leaflet/extendTile";

/*const client = new ApolloClient({
  uri:
    process.env.NODE_ENV === "production"
      ? "https://travelto.pythonanywhere.com/graphql"
      : "http://localhost:8000/graphql",
  cache: new InMemoryCache(),
  credentials: "include",
});*/

const client = new ApolloClient({
  uri: "https://travelto.pythonanywhere.com/graphql",
  cache: new InMemoryCache(),
  credentials: "include",
});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
